//合同管理
import request from '@/utils/request'

//新增合同信息
export function addContract(param) {
    return request.post('/contract/addContract', param)
}

//根据合同ID查询合同详情
export function queryListByContractId(contractId) {
    return request.post('/contract/queryListByContractId?contractId=' + contractId)
}

//新增支付订单并返回订单信息
export function addOrderAndReturn(param) {
    return request.post('/order/addOrderAndReturn', param)
}

//生成支付二维码
export function createPayQRCode(url) {
    return request.post('/QRCode/createPayQRCode?url=' + url)
}

//查询合同列表
export function queryContractByConditions(param) {
    return request.post('/contract/queryContractByConditions', param)
}